// Mirrors the server's supported source contracts. It cannot enable a
// runtime or grant save authority; the native server validates all writes.
export const HTML_CSS_JS_PROFILE = Object.freeze({
  id: 'html-css-js-v1',
  files: Object.freeze(['index.html', 'styles.css', 'script.js']),
})

export const REACT_PROFILE = Object.freeze({
  id: 'react-dom-v1',
  files: Object.freeze(['App.jsx', 'styles.css']),
})

export const PYTHON_PROFILE = Object.freeze({
  id: 'python-pyodide-v1',
  files: Object.freeze(['main.py']),
})

export function requireCodingProfile(definition) {
  const id = definition && Object.prototype.hasOwnProperty.call(definition, 'runnerProfile')
    ? definition.runnerProfile : HTML_CSS_JS_PROFILE.id
  if (id === HTML_CSS_JS_PROFILE.id && (!definition || definition.schemaRevision === undefined || definition.schemaRevision === 1)) {
    return HTML_CSS_JS_PROFILE
  }
  const runtimeProfile = id === REACT_PROFILE.id ? REACT_PROFILE : id === PYTHON_PROFILE.id ? PYTHON_PROFILE : null
  if (runtimeProfile && definition.schemaRevision === 2 &&
      typeof definition.runtimeArtifactId === 'string' && /^[a-f0-9]{64}$/.test(definition.runtimeArtifactId)) return runtimeProfile
  throw new Error('Unsupported coding question runner profile.')
}

export function codingIdentity(definition) {
  const profile = requireCodingProfile(definition)
  return profile !== HTML_CSS_JS_PROFILE
    ? { schemaVersion: 2, runnerProfile: profile.id, runtimeArtifactId: definition.runtimeArtifactId } : {}
}

export function requireAnswerProfile(answer, definition) {
  const profile = requireCodingProfile(definition)
  if (profile !== HTML_CSS_JS_PROFILE) {
    if (answer.schemaVersion !== 2 || answer.runnerProfile !== profile.id ||
        answer.runtimeArtifactId !== definition.runtimeArtifactId || !answer.files ||
        Object.keys(answer.files).length !== profile.files.length ||
        !profile.files.every(name => typeof answer.files[name] === 'string')) {
      throw new Error('The saved coding project does not match its pinned runtime.')
    }
  } else if (answer.schemaVersion !== 1) {
    throw new Error('Unsupported coding answer schema.')
  }
  return profile
}

// Preserve projection (including undefined values) and insertion order. Dirty
// comparisons and existing local recovery rely on this, not strict validation.
export const projectFiles = (files, profile = HTML_CSS_JS_PROFILE) => Object.fromEntries(
  profile.files.map(name => [name, files[name]]),
)
